/**
 * ShopSonix 2.0 Custom js for homepage
 * Extima Team
 * 
 */
var userFeed = new Instafeed({
        get: 'user',
		target: 'sonixfeed',
        userId: 39679214,
        accessToken: '39679214.41f0f4b.edd8fd01fe114d8e810cbef69c545528',
		resolution: 'standard_resolution',
		limit: 9,
		after: function () {
			var images = jQuery("#sonixfeed").find('a');
			jQuery.each(images, function(index, image) {
				var delay = (index * 75) + 'ms';
				jQuery(image).css('-webkit-animation-delay', delay);
				jQuery(image).css('-moz-animation-delay', delay);
				jQuery(image).css('-ms-animation-delay', delay);
				jQuery(image).css('-o-animation-delay', delay);
				jQuery(image).css('animation-delay', delay);
				jQuery(image).addClass('animated fadeIn sonixfeeditem-' + index);
				jQuery(image).attr('id', 'soniximg-' + index);
				if(index > 0){
					jQuery(image).addClass('col-sm-3');
					}
			});
		},
		template: '<a href="{{link}}" target="_blank" class="sonixfeeditem" style="background:url({{image}}) center center no-repeat;background-size:cover;"><img src="{{image}}" class="sonixfeedimg"/><div class="likes"><span><img src="https://cdn.shopify.com/s/files/1/2401/0807/t/2/assets/InstagramHeart.svg?2791056091801754598" class="snxheart" />{{likes}}</span></div></a>'
    });
    userFeed.run();
	
	
var userFeedMobile = new Instafeed({
        get: 'user',
		target: 'sonixfeedsmall',
        userId: 39679214,
        accessToken: '39679214.41f0f4b.edd8fd01fe114d8e810cbef69c545528',
		resolution: 'standard_resolution',
		limit: 4,
		after: function () {
			var images = jQuery("#sonixfeedsmall").find('a');
			jQuery.each(images, function(index, image) {
				var delay = (index * 75) + 'ms';
				jQuery(image).css('-webkit-animation-delay', delay);
				jQuery(image).css('-moz-animation-delay', delay);
				jQuery(image).css('-ms-animation-delay', delay);
				jQuery(image).css('-o-animation-delay', delay);
				jQuery(image).css('animation-delay', delay);
				jQuery(image).addClass('animated fadeIn sonixfeeditemmobile-' + index);
				jQuery(image).attr('id', 'soniximgmobile-' + index);
				jQuery(image).addClass('col-xs-6');
					
			});
		},
		template: '<a href="{{link}}" target="_blank" class="sonixmobilefeeditem" style="background:url({{image}}) center center no-repeat;background-size:cover;"><img src="{{image}}" class="sonixfeedimgmobile"/><div class="likes"><span><img src="/media/sonix2/svg/InstagramHeart.svg" class="snxheart" />{{likes}}</span></div></a>'
    });
    userFeedMobile.run();
	
	jQuery(window).load(function(){
		var windwidth = jQuery(window).width();
		var marheight = jQuery(".slideshow-section").height();
		
		if(windwidth >= 762) {
			jQuery(".home-inner1").css("margin-top", marheight + "px");
		} else {
			jQuery(".home-inner1").css("margin-top", "0px");
		}
		
		
		jQuery('#soniximg-0').nextUntil('#soniximg-9').wrapAll('<div class="col-sm-8" id="snfeedright"></div>');
		jQuery('#soniximg-0').wrap('<div class="col-sm-4" id="snfeedleft"></div>');
		var mobimgheight = jQuery("#soniximgmobile-0").height();
		var imgheight = jQuery("#soniximg-0").height()/2;
		var i;
		var j;
		var imgheight2 = imgheight * 2;
		for (i = 1; i <= 9; i++) {
			jQuery("#soniximg-" + i).height(imgheight);
			jQuery("#soniximg-" + i).find('.likes').css('height', imgheight + 'px');
		}
		for (j=0; j<=3; j++){
			jQuery("#soniximgmobile-" + j).find('.likes').css('height', mobimgheight + 'px');	
		}
		jQuery("#soniximg-0").find('.likes').css('height', imgheight2 + 'px');
		
	});
	
	jQuery(document).ready(function(){
		
		var fixmeTop = jQuery('.home-inner1').offset().top;       
		jQuery(window).scroll(function() {                  
		
			var currentScroll = jQuery(window).scrollTop();
		
			if (currentScroll >= fixmeTop) {           
				jQuery('.slideshow-section').addClass("myzindex");
			} else {                                  
				jQuery('.slideshow-section').removeClass("myzindex");
			}
		});
	});
	
	jQuery(window).resize(function(){
		
		var marheight2 = jQuery(".slideshow-section").height();
		var windwidth2 = jQuery(window).width();
		
		if(windwidth2 >= 762) {
			jQuery(".home-inner1").css("margin-top", marheight2 + "px");
		} else {
			jQuery(".home-inner1").css("margin-top", "0px");
		}
		var mobimgheight = jQuery("#soniximgmobile-0").height();
		var imgheight = jQuery("#soniximg-0").height()/2;
		var imgheight2 = imgheight * 2;
		var i;
		var j;
		jQuery("#soniximg-0").find('.likes').css('height', imgheight2 + 'px');
		for (i = 1; i <= 9; i++) {
			jQuery("#soniximg-" + i).height(imgheight);
			jQuery("#soniximg-" + i).find('.likes').css('height', imgheight + 'px');
		}
		for (j=0; j<=3; j++){
			jQuery("#soniximgmobile-" + j).find('.likes').css('height', mobimgheight + 'px');	
		}
		
		
	});